<div class="booking-card" (click)="open.emit(booking.id)">
  <div class="card-header">
    <span class="id">#{{ booking.id }}</span>
    <span class="status" [class]="booking.status.toLowerCase()">{{ booking.status }}</span>
  </div>

  <div class="card-body">
    <div class="flight-info">
      <span class="time">{{ booking.flight.time || '--:--' }}</span>
      <div class="route-info">
        <span class="route">{{ booking.flight.departure }} ✈ {{ booking.flight.arrival }}</span>
        <span class="flight-num">{{ booking.flight.flightNumber }}</span>
      </div>
    </div>

    <div class="passengers" *ngIf="totalPassengers > 0">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px; vertical-align: text-bottom;">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
      {{ totalPassengers }}
    </div>
  </div>

  <div class="card-footer">
    <span class="price">{{ booking.total | number:'1.0-2' }} ₽</span>
    <span class="action">Открыть →</span>
  </div>
</div>
